module.exports = __webpack_public_path__ + "img/AE9D99_29303B_585F70_875C33-256px.01d4ddde.png";